export const ROUTES = {
  LOGIN: "/",
  HOME: "home",
  PRODUCTS: "/home/products",
  UPLOAD: "/home/upload",
  SMARTSEARCH: "/home/smart-search",
  PRODUCTDETAILS: "/home/product-details",
  SEARCH: "/home/search",
  HELP: "/home/help",
};
